module.exports = __webpack_public_path__ + "img/co_icon.bbb8afbe.png";